import { IAffiliateListTableLang } from '../../../types/lang'

export const affiliateListTableLang: IAffiliateListTableLang = {
	affiliate_list_table: {
		column_id: 'ID_ru',
		column_name: 'Name_ru',
		column_percent: 'Percent, %_ru',
		column_notes: 'Notes_ru'
	}
}